import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useDownloadAudio } from '../../../../../../hooks/useDownloadAudio';
import caAPI from '../../../../../../services/caAPI';

import './style.scss';

export default function RecebeAudio({ url }) {
  const { configDownloadAudio, downloadAudio } = useDownloadAudio();
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    const isArquivosDommus = (() => {
      try {
        return (new URL(url)).hostname === 'arquivos.dommus.com.br';
      } catch {
        return false;
      }
    })();

    if (!isArquivosDommus) {
      return;
    }

    caAPI.arquivoAtendimento.downloadArquivoPrivado(url)
      .then((response) => {
        objectUrl = URL.createObjectURL(response.data);
        setBlobUrl(objectUrl);
      })
      .catch((error) => {
        console.error('Erro ao carregar áudio:', error);
      });
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  const handleDownloadAudio = useCallback(async () => {
    try {
      await downloadAudio(url);
    } catch (error) {
      console.error('Erro ao baixar áudio:', error);
    }
  }, [url, downloadAudio]);

  return (
    <div className="audio-player-container">
      <audio
        className="audio"
        controls
        preload="metadata"
        src={blobUrl || url}
      >
        <source src={blobUrl || url} type="audio/ogg" />
      </audio>
      {configDownloadAudio && (
        <Button 
          variant="outline-primary" 
          className="btn-download-audio"
          onClick={handleDownloadAudio}
          title="Baixar áudio"
        >
          <FontAwesomeIcon icon={faDownload} />
        </Button>
      )}
    </div>
  );
}
